import validate from '../../utils/validate';
import defaultSteps from './default_steps';
import defaultData from './default_data';
import constraints from './constraints';
import i18n from '../../i18n';

const defaultState = {
  currentStep: 0,
  steps: defaultSteps,
  data: defaultData,
  errors: {},
  loading: false,
  availDeliveryDays: []
};

const signupReducer = (state = defaultState, {type, payload}) => {
  switch (type) {
    case 'SET_DATA':
      let errors = {};

      for (const key in payload) {
        let err = validate(payload[key], constraints[key]);
        if (err !== null) {
          errors[key] = err;
        }
      }
      
      // TODO: fix validation to remove hardcoded constraints
      
      let localContactEmail = payload['contactEmail'] ? payload.contactEmail : state.data.contactEmail;
      let localContactEmailConfirmation = payload['contactEmailConfirmation'] ? payload.contactEmailConfirmation : state.data.contactEmailConfirmation;
      
      if (!errors['contactEmailConfirmation'] && localContactEmail !== localContactEmailConfirmation) {
        errors.contactEmailConfirmation = i18n.t('validationMessages.noEmailMatch');
      }
      
      let localSeason = payload['season'] ? payload.season : state.data.season;
      let localEventStartDate = payload['eventStartDate'] ? payload.eventStartDate : state.data.eventStartDate;
      let localEventEndDate = payload['eventEndDate'] ? payload.eventEndDate : state.data.eventEndDate;

      if (localSeason === 'event' && !localEventStartDate) {
        errors.eventStartDate = i18n.t('validationMessages.emptyPresence');
      }

      if (localSeason === 'event' && !localEventEndDate) {
        errors.eventEndDate = i18n.t('validationMessages.emptyPresence');
      }
      
      if (!errors['eventEndDate'] && localEventStartDate > localEventEndDate) {
        errors.eventEndDate = i18n.t('validationMessages.endDateBeforeStartDate');
      }
      
      let state_errors_filter = {}
      for (var i in state.errors) {
        if (!payload[i] &&
            i !== 'contactEmailConfirmation' &&
            i !== 'eventStartDate' &&
            i !== 'eventEndDate'
            ) {
              state_errors_filter[i] = state.errors[i];
        }
      }
      
      return {
        ...state,
        data: {...state.data, ...payload},
        errors: {...state_errors_filter, ...errors}
      };

    case 'SET_ERRORS':
      return {...state, errors: {...state.errors, ...payload}};

    case 'RESET_ERRORS':
      return {...state, errors: {}};

    case 'RESET_DATA':
      return {...state, data: defaultData};

    case 'SET_CURRENT_STEP':
      let [nextStep] = payload;

      window.scrollTo(0, 0);

      return {...state, currentStep: nextStep};

    case 'SET_LOADING':
      return {...state, loading: payload};

    case 'SET_AVAIL_DELIVERY_DAYS':
      return {...state, availDeliveryDays: payload};

    // CHECK
    // SEARCH DELIVERY AVAIL
    // SUBMIT

    default:
      return state;
  }
};

export default signupReducer;